import React from 'react';

import {
  Button, Image, Price
} from 'components/ui';
import IconCartArrow from 'components/ui/icons/IconCartArrow';
import { HOLIDAY_ICONS } from 'constants/seasonal';
import { useDrawerDispatchHelpers } from 'context/DrawerContext';
import { DRAWER_TYPES } from 'helpers/LayoutHelpers';
import { getActiveHoliday } from 'helpers/SeasonalHelpers';
import { cx } from 'helpers/StylingHelpers';
import { useActiveOrder } from 'hooks/data/useActiveOrder';

import { Holiday } from 'types/holidays';

import styles from './HeaderCartButton.module.scss';

interface Props {
  className?: string,
  btnClassName?: string,
  hideCartOnLargeScreens?: boolean,
  isMobile?: boolean
}

const CartButton = (props: Props) => {
  const {
    className,
    btnClassName,
    hideCartOnLargeScreens,
    isMobile
  } = props;

  const { data: order } = useActiveOrder();
  const { items = [], itemsTotal, currency } = order || {};
  const { showDrawer } = useDrawerDispatchHelpers();

  const handleClick = () => showDrawer(DRAWER_TYPES.CART);

  const classes = cx(
    styles.root,
    { [styles.alwaysShowCartButton]: !hideCartOnLargeScreens },
    { [styles.mobile]: isMobile },
    className
  );

  const isPriceVisible = !isMobile && Number(itemsTotal) > 0;

  return (
    <div className={classes}>
      <Button
        className={cx(styles.button, btnClassName)}
        size="medium"
        variant={isMobile ? 'subtle' : 'primary'}
        aria-label="Cart"
        onClick={handleClick}
      >
        {isPriceVisible && <Price currency={currency} value={itemsTotal} className={styles.price} />}
        <CartIcon />
      </Button>
      <div className={styles.quantityWrapper}>
        <div className={styles.quantity}>
          {items?.length || 0}
        </div>
      </div>
    </div>
  );
};

const CartIcon = () => {
  const holiday = getActiveHoliday();

  if (holiday) {
    const imageSrc = getHolidayImage(holiday);

    if (imageSrc) {
      return <Image height={22} width={22} src={imageSrc} />;
    }
  }
  return <IconCartArrow size={22} />;
};

function getHolidayImage(holiday: Holiday) {
  const holidayImages = {
    [Holiday.Easter]: HOLIDAY_ICONS.CART.EASTER,
    [Holiday.Christmas]: HOLIDAY_ICONS.CART.CHRISTMAS,
  };

  return holidayImages[holiday] || null;
}

export default CartButton;
